
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skigebiet",
      function () {
        return require("private-next-pages/[region]/[resort]/skigebiet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skigebiet"])
      });
    }
  